<template>
	<div class="grid grid-cols-1 gap-6 md:gap-8 text-sm leading-tight" :class="{'md:grid-cols-2': layout === 'modal'}">
		<section>
			<div>
				<img class="bg-white rounded-lg border max-w-[200px] p-2" :src="product?.institution.logo" />
			</div>

			<div class="mt-3 mb-4">
				<h2 class="text-xs font-semibold">{{ product?.academic_level.name }}</h2>
				<h3 class="text-2xl font-bold">{{ product?.title }}</h3>
			</div>

			<div>
				<p><strong>Tipo:</strong> {{ product?.academic_level.name }}</p>
				<p v-if="false">Duração: -TODO-</p>
				<p v-if="false">Parcelas: -TODO-</p>
				<p v-if="product?.starts_in"><strong>Ínicio:</strong> {{ product?.starts_in }}</p>
				<p v-if="product?.installments_starts_in"><strong>Primeira mensalidade:</strong> {{ product?.installments_starts_in }}</p>
			</div>

			<hr class="my-4 w-1/3" />

			<div class="grid grid-cols-1 gap-2">
				<div>
					<strong>Modalidade:</strong>
					<p>{{ product?.modality.name }}</p>
				</div>

				<div>
					<strong>Periodo:</strong>
					<p>{{ product?.shift.name }}</p>
				</div>

				<div>
					<strong>Polo:</strong>
					<p>{{ product?.unit?.name }}</p>
				</div>
			</div>

			<hr class="my-4 w-1/3" />

			<div class="flex flex-col lg:flex-row">
				<div v-if="product?.stock_available <= 5" class="flex text-primary font-semibold pl-[3px] lg:mt-2 mt-0">
					<div class="mr-[10px] mt-1"><img :src="urlAssets + '/img/checkout/bolsa.svg'" /></div>
					<div>Restam {{ product?.stock_available }} bolsas</div>
				</div>
				<hr v-if="product?.stock_available <= 5" class="lg:hidden w-1/2" />
				<div v-if="product?.stock_available <= 5" class="hidden lg:block mx-5 border-l h-10"></div>
				<ProductAdvantages
					:is_postpaid="product?.product_type === 'postpaid'"
					:is_full_period_discount="product?.is_full_period_discount"
					:is_first_month_free="product?.is_first_month_free" />
			</div>
		</section>

		<hr v-if="layout !== 'modal'" />

		<section>
			<Badge icon="bxs:info-circle" class="h-12">
				<p class="block mx-auto py-2 w-12 text-right text-white text-xs">
					Bolsa de
					<strong class="text-lg leading-3">{{ product?.discount }}%</strong>
				</p>
			</Badge>

			<PosPaidBadge v-if="product?.product_type === 'postpaid'" />

			<div class="my-4" v-if="product?.saved_amount">
				<h2 class="text-gray-400">Economia Total no final do curso</h2>
				<p class="text-lg font-bold">R$ {{ usePrice(product?.saved_amount) }}</p>
			</div>

			<hr class="my-4 w-1/3" />

			<div class="my-4">
				<p class="text-gray-400">de <span class="line-through">R${{ usePrice(product?.regular_price) }}/mês</span></p>
				<p class="text-2xl font-bold">R${{ usePrice(product?.sale_price) }}/mês</p>
				<p
					v-if="!product?.is_full_period_discount && !!product?.discount_period"
					class="text-gray-400">
					<span v-if="!!product?.discount_instalments && product?.default_sale_price">
						Depois de {{ product?.discount_instalments }} meses, pague R${{ usePrice(product?.default_sale_price) }}
					</span>
					<span v-else>
						{{ product?.discount_period }}
					</span>
				</p>
				<p v-if="product?.is_full_period_discount" class="text-gray-400">Desconto durante todo o curso</p>
			</div>

			<div class="my-4" v-if="order && order.voucher">
				Com o uso do cupom <b>{{ order.voucher }}</b> você paga na sua inscrição
				<p class="font-bold text-[24px]">R${{ usePrice(order.price) }}</p>
			</div>

			<div class="my-4" v-else-if="coupon_description">
				<client-only>
					<div v-html="coupon_description"></div>
				</client-only>
			</div>

			<div class="error-label" v-if="product?.stock_available === 0">
				Produto sem estoque!
			</div>

			<hr class="my-4 w-1/3" />

			<div>
				<button type="button" @click="() => about_scholarship.open()" class="underline cursor-pointer">Mais informações sobre a bolsa</button>
			</div>

			<CommonButton
				v-if="hasAction"
				text="Avançar"
				class="w-full mt-4 h-14 justify-between"
				icon="bi:arrow-right-circle-fill"
				:disabled="product?.stock_available === 0"
				@click="()=> emit('onClick')"
			/>
		</section>

		<Modal ref="about_scholarship">
			<template #layout>
				<div class="max-w-3xl p-12 mx-auto bg-white z-10 w-full max-h-screen overflow-y-scroll relative">
					<button
						@click="about_scholarship.close()"
						class="absolute right-0 top-0 mr-3 mt-2"
						type="button">X</button>
					<article>
						<h3 class="font-bold text-xl">Sobre a bolsa:</h3>
						<ul class="mx-12 mt-4 list-disc flex flex-col gap-4">
							<li>
								Após realizar a compra da bolsa aqui no site do Vai de Bolsa,
								o aluno receberá um voucher contendo todas as informações
								referente ao curso, turno, modalidade e instituição escolhidos,
								além do link para realizar a inscrição na instituição.
							</li>
							<li>
								O aluno só terá direito à bolsa caso realize a inscrição para o
								processo seletivo correspondente à forma de ingresso escolhida,
								através do link enviado pelo Vai de Bolsa.
							</li>
							<li>
								Se o estudante já se matriculou no processo seletivo, ele precisa
								solicitar o cancelamento desta inscrição para a instituição e
								realizar uma nova a partir do link que receberá do Vai de Bolsa,
								para que o desconto seja válido.
							</li>
						</ul>
					</article>
					<article class="flex flex-col gap-6 mt-12">
						<section>
							<h3 class="font-bold text-xl">Avisos importantes:</h3>
							<ul class="mx-12 mt-4 list-disc flex flex-col gap-4">
								<li>Após realizar a compra da bolsa, o aluno receberá um link para realizar a inscrição no site da  instituição e um voucher que deverá ser anexado durante o processo.</li>
								<li>Após a aprovação no processo seletivo da instituição, conforme o método de entrada escolhido na realização da inscrição, o aluno já poderá usufruir dos benefícios da sua bolsa.</li>
								<li>Ao realizar a matrícula na instituição, você estará contratando todo o ciclo acadêmico, seja ele semestral, trimestral ou anual. Por isso, é importante destacar que caso você ingresse na metade do ciclo acadêmico, será necessário pagar as mensalidades anteriores à data de ingresso referente àquele ciclo acadêmico.</li>
							</ul>
						</section>
						<section>
							<h3 class="font-bold text-xl">Regras e observações:</h3>
							<ul class="mx-12 mt-4 list-disc flex flex-col gap-4">
								<li v-if="product?.institution?.partner_id === '2ee389d2-7e3e-4b80-b136-60fcd255452e'">
									Caso o pagamento da mensalidade ultrapasse a data do vencimento, a IES poderá realizar a retirada total ou parcial da bolsa.
								</li>
								<li v-if="product?.institution?.partner_id === '2ee389d2-7e3e-4b80-b136-60fcd255452e'">
									Essa condição será aplicada individualmente para cada mensalidade.
								</li>
								<li v-else>O desconto será aplicável apenas para pagamentos realizados até a data de vencimento determinada pela instituição na hora da matrícula.</li>
								<li>O desconto é de responsabilidade da instituição e poderá sofrer mudanças sem aviso prévio. E, em caso de divergência, prevalecerão as informações da instituição.</li>
								<li>O usuário tem até 15 dias corridos para solicitar o reembolso, caso desista da compra.</li>
								<li>Caso o motivo para solicitar o reembolso for por não formação de turma no curso escolhido, problemas de saúde e/ou doença crônica, é possível solicitar o reembolso em até 30 dias corridos, contados a partir do início do ciclo/semestre na instituição.</li>
								<li>O valor do reembolso pode demorar de 5 a 10 dias úteis.</li>
								<li>Vale lembrar que o contrato de matrícula/inscrição é realizado juntamente com a instituição, por isso, <b>nós realizamos apenas o estorno da compra, e a solicitação do cancelamento da matrícula/inscrição deverá ser realizada diretamente com a instituição de ensino</b>, para ter certeza de que as mensalidades futuras não serão lançadas.</li>
							</ul>
							<br/>
							Para saber mais detalhes, leia os nossos <a class="underline" target="_blank" href="https://vaidebolsa.com.br/termos-de-uso-e-politica-de-reembolso">Termos de Uso e Política de Reembolso.</a>
						</section>
					</article>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script lang="ts" setup>
	import { computed, ref, useRuntimeConfig } from "#imports";
	import { storeCoupon } from "~/store/coupon";
	import { usePrice } from "~/composables/usePrice";
	import Badge from "~/components/app/badge.vue";
	import CommonButton from "~/components/common/button.vue";
	import PosPaidBadge from "~/components/content/badge/postpaid-badge.vue";
	import ProductAdvantages from '~/components/common/product-advantages.vue'
	import Modal from "~/components/common/modal.vue";

	const runtimeConfig = useRuntimeConfig();
	const urlAssets = runtimeConfig.assetsUrl;

	const { product, order, layout, hasAction } = defineProps({
		product: Object,
		order: Object,
		hasAction: {
			type: Boolean,
			default: () => true
		},
		layout: {
			type: String,
			default: () => "default",
		}
	});

	const emit = defineEmits(["onClick"]);

	const couponStore = storeCoupon();
	const discount_code = ref(null);
	const about_scholarship = ref();

	const coupon_description = computed(() => {
		const coupon = discount_code.value;
		if (!coupon) return null;
		const coupon_info = couponStore.coupon || {};
		return `
			Com o uso do cupom <b>${coupon.voucher}</b>
			você paga na ${coupon_info.discount_on === "enroll" ? "compra da bolsa" : "parcela"}
			<p class="font-bold text-[24px]">R$ ${usePrice(coupon.price)}</p>
		`;
	});

	if (process.client) {
		const coupon = couponStore.coupon || {};
		if (!!coupon.discount && !!couponStore.code) {
			discount_code.value = await couponStore.calculate(product?.id).catch(() => null);
		}
	}
</script>

<style scoped>
	/* .default {
		@apply flex flex-col lg:flex-row justify-between;
	}
	.default .section1 {
		@apply w-full lg:w-1/2 lg:border-r lg:pr-5;
	}
	.default .section2 {
		@apply w-full lg:w-1/2 lg:pl-4 flex flex-col justify-between mt-5 lg:mt-0;
	}
	.default .section1 hr:last-child {
		@apply lg:hidden;
	}
	.compact {
		@apply flex flex-col p-4 w-full;
	}
	.compact .section1 {
		@apply w-full;
	}
	.compact .section2 {
		@apply w-full mt-5;
	} */
</style>
